import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import { setAuth, getAuth } from '@/utils';
import { getUserLoginWithToken, getUserLoginWithQueryToken } from '@/services/user';
import {
  TOKEN_NAME,
  MINI_PROGRAM_TOKEN_NAME,
  APP_TOKEN_NAME,
} from '@/utils/constant';
import reloadPage from '@/utils/reload';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/marketing',
      name: 'Marketing',
      component: () => import('@/layout/RouterView').catch(reloadPage),
      children: [
        {
          path: '2019',
          name: 'Marketing2019',
          component: () => import('@/layout/RouterView').catch(reloadPage),
          children: [
            {
              path: 'national/day/project',
              name: 'Marketing2019NationalDay',
              component: () => import('@/pages/2019/NationalDayProject').catch(reloadPage),
            },
            {
              path: 'liuxuan/psychology',
              name: 'Marketing2019MuseumDay',
              component: () => import('@/pages/2019/LiuXuanPsychology').catch(reloadPage),
            },
            {
              path: 'autumn/course',
              name: 'Marketing2019AutumnCourse',
              component: () => import('@/pages/2019/AutumnCourse').catch(reloadPage),
            },
            {
              path: 'oct/course',
              name: 'Marketing2019OctoberCourse',
              component: () => import('@/pages/2019/OctoberCourse').catch(reloadPage),
            },
            {
              path: 'nov/course',
              name: 'Marketing2019NovemberCourse',
              component: () => import('@/pages/2019/NovemberCourse').catch(reloadPage),
            },
            {
              path: 'scholarship/plan',
              name: 'ScholarshipPlan',
              component: () => import('@/pages/2019/ScholarshipPlan').catch(reloadPage),
            },
            {
              path: 'birthday',
              name: 'Birthday',
              component: () => import('@/pages/2019/Birthday').catch(reloadPage),
            },
          ],
        },
        {
          path: '2020',
          name: 'Marketing2020',
          component: () => import('@/layout/RouterView').catch(reloadPage),
          children: [
            {
              path: 'spring/course',
              name: 'SpringCourse',
              component: () => import('@/pages/2020/SpringCourse').catch(reloadPage),
            },
            {
              path: 'may/course',
              name: 'MayCourse',
              component: () => import('@/pages/2020/MayCourse').catch(reloadPage),
            },
            {
              path: 'birthday',
              name: 'Birthday2020',
              component: () => import('@/pages/2020/Birthday').catch(reloadPage),
            },
          ],
        },
      ],
    },
    {
      path: '/marketing/common/activity/:type(\\w+)',
      name: 'DefaultActivity',
      component: () => import('@/pages/DefaultActivityPage').catch(reloadPage),
    },
    {
      path: '/500',
      name: 'Error500',
      component: () => import('@/pages/Error/500').catch(reloadPage),
    },
    {
      path: '/403',
      name: 'Error403',
      component: () => import('@/pages/Error/403').catch(reloadPage),
    },
    {
      path: '/404',
      name: 'Error404',
      component: () => import('@/pages/Error/404').catch(reloadPage),
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (/^(\/)?http(s)?:\/\//.test(to.path)) {
    window.location.href = to.path.replace(/^\//, '');
    return;
  }

  if (!to.matched || to.matched.length === 0) {
    next({ name: 'Error404', replace: true });
    return;
  }

  // 获取本地缓存用户验证
  const auth = getAuth();

  // 获取URI query 中的token 进行登录
  const { query } = to;
  const {
    [TOKEN_NAME]: mWApiToken,
    [MINI_PROGRAM_TOKEN_NAME]: miniToken,
    [APP_TOKEN_NAME]: mApiToken,
  } = query;
  if (mWApiToken || miniToken || mApiToken) {
    // 清空当前登录用户信息
    setAuth('');
    // 尝试使用query token 登录
    await getUserLoginWithQueryToken({
      mWApiToken,
      miniToken,
      mApiToken,
    });
  }

  // 获取是否新建App
  const { newApp } = store.getters;
  if (newApp && auth === '') {
    // 尝试登录
    await getUserLoginWithToken();
  }

  const { meta, fullPath } = to;
  if (meta && meta.auth) {
    if (!auth || auth === '') {
      next({ name: 'Login', query: { redirectTo: fullPath }, replace: true });
      return;
    }
  }
  next();
});

export default router;
